module.exports = __webpack_public_path__ + "static/media/ins16.d3b998ca.jpg";